import { useState, useRef, useEffect, useMemo } from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useDebouncedFn = (fn) => {
    const timeout = useRef(undefined);
    const debouncedFn = useMemo(() => {
        return (...args) => {
            clearTimeout(timeout.current);
            timeout.current = setTimeout(() => fn(...args), 500);
        };
    }, [fn]);
    return debouncedFn;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebouncedVal = (value) => {
    const [debouncedVal, setDebouncedVal] = useState(value);
    const debouncedFn = useDebouncedFn(() => setDebouncedVal(value));
    useEffect(debouncedFn);
    return debouncedVal;
};
export default useDebouncedFn;
